import workspace from "../workspace";
import sqftShapeManager from "../../store/sqftShapeManager";
import Rectangle from "../shapes/layouts/rectangle";
import {SHAPE_PART_ID} from "../../../../constants";
import Polygon from "../shapes/layouts/polygon";

class CabinetShapes {
  /*
  *    /‾‾‾|
  *   /   /
  *   |__/
   */
  upperLayoutType1 = ['SM-DCW2436', 'SW-DCW2430', 'SM-DCW2442'];
  upperShapes = [];
  lowerShapes = [];

  addUpperShape = (feature, parentFeature, width, height, depth) => {
    const shape = this.getUpperShapeLayout(feature, width, height, depth);
    const shapeParams = {
      shapeCabinet: true,
      canSnap: true,
      width,
      height,
      depth
    };
    let shapeId = sqftShapeManager.addShape(shape, 'square', null, SHAPE_PART_ID.top_cabinet, null, shapeParams);
    sqftShapeManager.setShapeFeatureId(shapeId, feature.id);
    sqftShapeManager.setShapeRelatedParentFeatureId(shapeId, parentFeature.dbFeature.id);
    this.upperShapes.push(shapeId);
  }

  addLowerShape = (feature, parentFeature, width, height, depth) => {
    const shape = this.getLowerShape(feature, width, height, depth);
    const shapeParams = {
      shapeCabinet: true,
      canSnap: true,
      width,
      height,
      depth
    };
    let shapeId = sqftShapeManager.addShape(shape, 'square', null, SHAPE_PART_ID.bottom_cabinet, null, shapeParams);
    sqftShapeManager.setShapeFeatureId(shapeId, feature.id);
    sqftShapeManager.setShapeRelatedParentFeatureId(shapeId, parentFeature.dbFeature.id);
    this.lowerShapes.push(shapeId);
  }

  getLowerShape = (feature, width, height, depth) => {
    if (feature && feature.sharedFeatureName === 'SM-ERB36/BER36'
      || feature && feature.part && feature.part.dbFeature.sharedFeatureName === 'SM-ERB36/BER36'
    ) {
      //const gap1 = 10;
      //const gap2 = 10;
      // let pointCords = [
      //   {x: gap1, y: 0},
      //   {x: width, y: 0},
      //   {x: width, y: height - gap2},
      //   {x: width - gap2, y: height - gap2},
      //   {x: width - gap2, y: height},
      //   {x: 0, y: height},
      //   {x: 0, y: height - gap1},
      // ];
      const gap1 = 9.36;
      const gap2 = 9.36;
      width = 33.36;
      depth = 33.36;
      let pointCords = [
        {x: gap1, y: 0},
        {x: width, y: 0},
        {x: width, y: depth - gap2},
        {x: width - gap2, y: depth - gap2},
        {x: width - gap2, y: depth},
        {x: 0, y: depth},
        {x: 0, y: gap1},
      ];
      return new Polygon(pointCords, feature, feature);
    }

    return new Rectangle(width, depth);
  }

  getUpperShapeLayout = (feature, width, height, depth) => {
    if (feature && this.upperLayoutType1.includes(feature.sharedFeatureName)
      || feature && feature.part && this.upperLayoutType1.includes(feature.part.dbFeature.sharedFeatureName)
    ) {
      const gap1 = 3;
      const gap2 = 12; //15
      width = 24; //27
      depth = 24; //27
      let pointCords = [
        {x: gap1, y: 0},
        {x: width, y: 0},
        {x: width, y: depth - gap2},
        //{x: width - gap2, y: height - gap2},
        {x: width - gap2, y: depth},
        {x: 0, y: depth},
        {x: 0, y: gap1},
      ];
      return new Polygon(pointCords, feature, feature);
    }

    return new Rectangle(width, depth);
  }

  resetUpperShapes = () => {
    this.upperShapes = [];
  }

  importData = (data) => {
    //todo
    this.resetBacksplashes();
    for (let activeBacksplashData of data) {
      let shape = workspace.importShape(activeBacksplashData.backsplashShape);
      shape.deregisterEvents();
      let line = workspace.getLineById(activeBacksplashData.line.id);
      let slabAdditionalShape = new SlabAdditionalShape(line, shape.id);
      this.addActiveBacksplash(slabAdditionalShape);
    }
  }

  exportData = () => {
    //todo
    return this.additionalShapes
      .filter( SlabAdditionalShape => {
        let backsplashShape = workspace.getShapeById(SlabAdditionalShape.backsplashShapeId);
        return backsplashShape.partId !== SHAPE_PART_ID.seamPiece;
      })
      .map( SlabAdditionalShape => {
      let backsplashShape = workspace.getShapeById(SlabAdditionalShape.backsplashShapeId);

      return {
        backsplashShape: backsplashShape.export(),
        line: SlabAdditionalShape.line.export()
      }
    })
  }

  addActiveBacksplash = (SlabAdditionalShape) => {
    //todo
    this.additionalShapes.push(SlabAdditionalShape);
  }

  findAdditionalShapeByLine = (line) => {
    //todo
    return this.additionalShapes.find(additionalShape => additionalShape.line.id === line.id);
  }

  removeActiveBacksplashByLine = (line) => {
    //todo
    for (let i = this.additionalShapes.length - 1; i >= 0; i--) {
      if (this.additionalShapes[i].line.id === line.id) {
        workspace.removeShapeById(this.additionalShapes[i].backsplashShapeId);
      }
    }
  }

  removeShapeFromList = (shapeToRemove) => {
    //todo
    this.additionalShapes = this.additionalShapes.filter(additionalShape => additionalShape.backsplashShapeId !== shapeToRemove.id);
  }
}

export default CabinetShapes;
